import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import colors from 'vuetify/lib/util/colors'
import Touch from 'vuetify/es5/directives/touch'

Vue.use(Vuetify, {
  iconfont: 'md',  
  theme: {
    primary: colors.blue,
    secondary: colors.grey.lighten1,
    accent: colors.orange,
    error: colors.red.accent3
  },
  directives: {
    Touch
  }
})
